import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4ccf04a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c4ccf04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ccf04a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\hongyou\\background_ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ccf04a')) {
      api.createRecord('c4ccf04a', component.options)
    } else {
      api.reload('c4ccf04a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4ccf04a&scoped=true&", function () {
      api.rerender('c4ccf04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/index.vue"
export default component.exports